<template>
  <h1>{{config.title}}</h1>
</template>

<script>
const axios = require("axios");

export default {
  props: ["config"],
  data() {
    return {};
  },
  mounted() {}
};
</script>

<style scoped>
h1 {
  text-align: center;
  font-size: 24px;
  font-weight: 700;
  padding: 0px 40px;
}
</style>



// WEBPACK FOOTER //
// src/pages/cms/pageComponents/TitleComponent.vue